import { z } from 'zod/v3';
import { isDayjs } from 'dayjs';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { errorMap, ISO_DATE_FORMAT, zIsoDate } from '../../common/utils';

const { t } = i18nNsFactory('validation-rule-test-run-modal');

export const ValidationRuleTestRunValidFormSchema = z.object({
  validationRuleId: z.number(),
  valueDate: z.preprocess(
    (v) => {
      if (v == null || v === '') return undefined;
      if (isDayjs(v)) return v.format(ISO_DATE_FORMAT);
      if (typeof v === 'string') return v;
      return v;
    },
    zIsoDate(() => t('validation.valueDate.required')),
  ),
  outputDataVersionId: z
    .number(errorMap(() => t('validation.outputDataVersion.required')))
    .min(1),
});
